import { createSvgIcon } from '@mui/material/utils';

export const SketchIcon = createSvgIcon(
  <g fillRule="nonzero" fill="none">
    <path fill="#FDB300" d="M5.24 2.7L12 2l6.76.7L24 9.48 12 23 0 9.49z" />
    <path fill="#EA6C00" d="M4.85 9l7.13 14L0 9zM19.1 9l-7.12 14L23.95 9z" />
    <path fill="#FDAD00" d="M4.85 9H19.1l-7.12 14z" />
    <g>
      <path fill="#FDD231" d="M11.98 2l-6.75.65-.38 6.34zM11.98 2l6.75.65.37 6.34z" />
      <path fill="#FDAD00" d="M23.95 9l-5.22-6.35.37 6.34zM0 9l5.23-6.35-.38 6.34z" />
      <path fill="#FEEEB7" d="M11.98 2L4.85 9H19.1z" />
    </g>
  </g>,
  'Sketch',
);
